import React from 'react';

interface SubmitAnswerRowProps {
    riskGap: RiskGapType;
}
export function SubmitAnswerRow({ riskGap }: SubmitAnswerRowProps) {
    const formattedAnswer = React.useMemo(() => {
        switch (riskGap.submission_answer?.answer) {
            case 1:
                return 'Agree';
            case 2:
                return 'Disagree';
            default:
                break;
        }

        return 'Not Addressed';
    }, [riskGap.submission_answer]);

    return !riskGap.is_added ? (
        <tr key={riskGap.icd?.code}>
            <td>{riskGap.icd?.code}</td>
            <td>{formattedAnswer}</td>
        </tr>
    ) : (
        <tr key={riskGap.code}>
            <td>
                <span>{riskGap.code} - </span>
                <span className="fst-italic text-break">{riskGap.description}</span>
            </td>
            <td>{formattedAnswer}</td>
        </tr>
    );
}
